import React, { useState, useEffect, useMemo } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { UpdatePencil, DropdownArrow, SearchBig, AddwithWhiteCircle, DocImg, Percentage } from "../AllSvg";
import { Modal, ModalHeader, ModalBody } from 'react-bootstrap';

// import Createnewall from "../Modals/Createnewall";
import { handleErrorToast } from "../CustomFunctions";
import Select from "react-select";

const AddActivity = ({ projectID, department_name, getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(weightage, 'weightage')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: 'internal',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department: department_name ? department_name : "",
        // activity_parent: '',
        assigned_by: '',
        assigned_to: [],
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)


    const [selectedFile, setSelectedFile] = useState(null);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        // const file = e.target.files[0];
        // setSelectedFile(file);
        const file = e?.target?.files;
        if (file && files.length > 0) {
            const file = files[0];
            setSelectedFile(file);
            // Clear any previous errors if needed
            setErrors({ length: 0 });
        } else {
            // Handle case where no file is selected (optional)
            setSelectedFile(null);
            setErrors({ length: 1 }); // or whatever logic you prefer
        }
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);


    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/activityfilter-by-department/${department_name}/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {
        if (show) {
            getEmployeeDetails();
            fetchActivity()
        }

    }, [show]);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });




                if (formData.uploaded_file) {
                    formDataToSend.append("uploaded_file", customFile2);
                }



                let res = await axios.post(
                    `${BASE_URL}/detail-design/activitytype/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const [vendorList, SetVendorList] = useState([]);
    const getAllVendor = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/vendor/`);
            SetVendorList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };

    useEffect(() => {
        if (show) {
            getAllVendor()
        }
    }, [show])

    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            {/* <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ?
                                    (
                                        <div className="form-loader">
                                            <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                id="activity_parent"
                                                name="activity_parent"
                                                value={formData.activity_parent}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.activity_parent
                                                    ? "error"
                                                    : inputState.activity_parent
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Activity</option>
                                                {allActivity?.sort((a, b) => a?.activity_name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i?.activity_name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.department && (
                                                    <span className="error-message font-size-text ">
                                                        {errors.department}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}

                            </div> */}

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    <div title="Vendor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                            Select Existing Vendor <span className="required">*</span>
                                        </label>

                                        <select
                                            id="vendor_name"
                                            name="vendor_name"
                                            value={formData?.vendor_name}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Vendor</option>
                                            {vendorList?.sort((a, b) => a?.name?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                {console.log(i)}
                                                <option value={i?.id}>{i?.name}</option>
                                            </>))
                                            }
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.vendor_name && (
                                                <span className="error-message font-size-text ">{errors.vendor_name}</span>
                                            )}
                                        </div>
                                    </div>
                                </>)}

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>



                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {selectedFile ? selectedFile.name : "Select File"}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const EditActivity = ({ i, projectID, department_name, getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(i, 'i')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: '',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department_name: department_name ? department_name : "",
        activity_parent: '',
        assigned_by: '',
        assigned_to: '',
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)


    const [selectedFile, setSelectedFile] = useState(null);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        const file = e?.target?.files;
        if (file && files.length > 0) {
            const file = files[0];
            setSelectedFile(file);
            // Clear any previous errors if needed
            setErrors({ length: 0 });
        } else {
            // Handle case where no file is selected (optional)
            setSelectedFile(null);
            setErrors({ length: 1 }); // or whatever logic you prefer
        }
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
        setFormData(i)

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/activitytype/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {

        getEmployeeDetails();
        fetchActivity()
    }, []);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });





                formDataToSend.append("uploaded_file", customFile2);


                let res = await axios.put(
                    `${BASE_URL}/detail-design/activitytype/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Edit Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData?.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_name ? 'error' : inputState.activity_name ? 'success' : ''}`}
                                />
                                {errors.activity_name && <span className="error-message">{errors.activity_name}</span>}
                            </div>
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData?.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors?.activity_type
                                        ? "error"
                                        : inputState?.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors?.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors?.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData?.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            id="activity_parent"
                                            name="activity_parent"
                                            value={formData?.activity_parent}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.activity_parent
                                                ? "error"
                                                : inputState.activity_parent
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Activity</option>

                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.department && (
                                                <span className="error-message font-size-text ">
                                                    {errors.department}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    <div className="flex-column">
                                        <label className="form-labels">Vendor Name<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter the Vendor Name"
                                            name="vendor_name"
                                            value={formData?.vendor_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.vendor_name ? 'error' : inputState.vendor_name ? 'success' : ''}`}
                                        />
                                        {errors.vendor_name && <span className="error-message">{errors.vendor_name}</span>}
                                    </div>
                                </>)}
                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData?.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData?.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData?.deadline_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            {/* <div
                                // className="flex-column full-width-form"
                                className={formData?.activity_type === "internal" ? "flex-column full-width-form" : "flex-column"}
                            >
                                <label className="form-labels"> Documentations : <span className="required">*</span></label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file" >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">Select File</span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    // className={`form-input  ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                                    style={{ display: "none" }}
                                />
                                {errors.length && <span className="error-message">{errors.length}</span>}
                            </div> */}

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {selectedFile ? selectedFile.name : "Select File"}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const AddDepartment = ({ projectID, getDepartmentList, departmentlist }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: [],  // [{ emp_code: "", name: "" }]
        employee: [],   // [{ emp_code: "", name: "" }]
        project: projectID || "",
        division_name: '',
        division: "null",
        weightage: "",
        division_head: [], // [{ emp_code: "", name: "" }]
        activity: [],
        activity_details: [
            {
                name: "",
                code: "",
                sub_activity_count: "",
                document: [],
                weightage_percentage: "",
                status: "pending",
                id: "null",
            }
        ],
        subactivity: [
            {
                name: "",
                code: "",
                weightage: "",
                document: [],
                start_date: null,
                end_date: null,
                status: "pending",
                activity_id: "null",
                id: "null",

            }
        ]
    });







    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            // 'department_type',
            // 'client',
            // "sub_Company",
            // "concern_person",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {



                let res = await axios.post(
                    `${BASE_URL}/detail-design/highwaydepartment/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    setShow(false);
                    handleClose();
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    console.log("projectID")
    console.log(projectID)

    console.log("formData")
    console.log(formData)



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        setFormData2((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            department: '',
            team_lead: [],
            employee: [],
            project: projectID ? projectID : "",
            department_type: '',
            division_name: '',
            weightage: "",
            division_head: [],
        })

    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/detail-design/allprojectfilter/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {
        const id = '025d0b52-e892-4868-a3bb-6b70dcdffb4d';
        try {
            const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${id}/active/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    const [division, setDivision] = useState([])

    const getDivisionData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/division/`);
            const divisions = res.data || [];
            setDivision(divisions);
            console.log("Divisions:", divisions);
        } catch (err) {
            console.error("Error fetching divisions:", err);
            toast.error("Failed to fetch division data!");
        }
    };

    useEffect(() => {
        if (show) {
            setFormData((prevState) => ({
                ...prevState,
                department_type: 'internal',
            }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
            getDivisionData()
        }

    }, [show]);

    const selectTeamLead = (selected) => {
        const team_lead = selected?.length > 0 ? selected?.map(item => item.value) : "";

        setFormData(prevState => ({
            ...prevState,
            team_lead
        }));
    };



    const selectHeadDivision = (selected) => {
        const division_head = selected?.length > 0 ? selected?.map(item => item.value) : "";

        setFormData(prevState => ({
            ...prevState,
            division_head
        }));
    };



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };


    const selectEmployee = (selected) => {
        const employee = selected?.length > 0 ? selected?.map(item => item.value) : "";

        setFormData(prevState => ({
            ...prevState,
            employee
        }));
    };





    const [formdata2, setFormData2] = useState({
        name: "",
        contact_person: "",
        // sub_Company: "",
        address: "",
        email: "",
        contact_number: "",
        alt_contact_number: "",
        gstin_number: "",
        pos: ""
    })

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = [
            // "sub_Company",
            "pos",
            "name",
            "gstin_number",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });





        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [sub_CompanyList, setsub_CompanyList] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const handleAddVendor = () => {
        setShowForm(!showForm);
    };
    const handleSubmitVendor = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formdata2).forEach((key) => {

                    formDataToSend.append(key, formData[key]);

                });







                let res = await axios.post(
                    `${BASE_URL}/detail-design/vendor/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShowForm(false);
                    setFormData2(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );


                    setFormData((prevData) => ({
                        ...prevData,
                        vendor_name: res.data.id
                    }));
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getAllVendor();
                }

                else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const getAllsub_Company = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/subCompany/`);
            setsub_CompanyList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };
    useEffect(() => {
        getAllVendor();
        getAllsub_Company();


    }, [])
    const [vendorList, SetVendorList] = useState([]);
    const getAllVendor = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/vendor/`);
            SetVendorList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };




    const filterDivision = division.filter(i => i.id === formData.division);
    const activiayData = useMemo(() =>
        filterDivision.flatMap(division => division?.activity || []),
        [filterDivision]
    );

    const activityDetails = useMemo(() =>
        activiayData.map(activity => ({
            name: activity.activity_name || "",
            code: activity.activity_code || "",
            sub_activity_count: activity.subactivities?.length || 0,
            document: [],
            weightage_percentage: "",
            id: activity.id,
            status: "pending"
        })),
        [activiayData]
    );

    const subactivityDetails = useMemo(() =>
        activiayData.flatMap(activity =>
            activity.subactivities?.map(sub => ({
                name: sub.subactivity_name || "",
                code: sub.subactivity_code || "",
                weightage: "",
                document: [],
                start_date: null,
                end_date: null,
                status: "pending",
                assign_to: [],
                id: sub.id,
                activity_id: activity.id || null
            })) || []
        ),
        [activiayData]
    );




    useEffect(() => {
        setFormData(prev => {
            const newData = {
                ...prev,
                activity: activiayData,
                activity_details: activityDetails,
                subactivity: subactivityDetails
            };

            // Avoid re-render if data hasn't actually changed
            if (JSON.stringify(prev) === JSON.stringify(newData)) {
                return prev;
            }

            return newData;
        });
    }, [activiayData, activityDetails, subactivityDetails]);











    return (
        <>
            <button
                title="Add Division"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />  Division
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Division</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Name <span className="required">*</span></label>
                                {division.length === 0 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            id="division"
                                            name="division"
                                            value={formData.division}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.division
                                                ? "error"
                                                : inputState.division
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a devision</option>
                                            {division
                                                ?.sort((a, b) =>
                                                    a?.name?.localeCompare(b.project_name, "en", {
                                                        ignorePunctuation: true,
                                                    })
                                                )
                                                .map((i, index) => (
                                                    <>

                                                        <option value={i.id}>{i.division_name}</option>
                                                    </>
                                                ))}
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.division_name && (
                                                <span className="error-message font-size-text ">
                                                    {errors.division_name}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                            {formData?.department_type === "internal" ?
                                (
                                    <>



                                        <div className="flex-column form-group-selectt">
                                            <label className="form-labels">Department <span className="required">*</span></label>



                                            {allDepartments.length === 0 ? (
                                                <div className="form-loader">
                                                    <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                                </div>
                                            ) : (
                                                <>
                                                    <select
                                                        id="department"
                                                        name="department"
                                                        value={formData.department}
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.department
                                                            ? "error"
                                                            : inputState.department
                                                                ? "success"
                                                                : ""
                                                            }`}
                                                    >
                                                        <option value="">Select a Department</option>
                                                        {allDepartments
                                                            ?.sort((a, b) =>
                                                                a?.name?.localeCompare(b.project_name, "en", {
                                                                    ignorePunctuation: true,
                                                                })
                                                            )
                                                            .map((i, index) => (
                                                                <>

                                                                    <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                                </>
                                                            ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.department && (
                                                            <span className="error-message font-size-text ">
                                                                {errors.department}
                                                            </span>
                                                        )}
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Head Of Division:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectHeadDivision}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />


                                            {errors.division_head && (
                                                <span className="error-message font-size-text ">{errors.division_head}</span>
                                            )}
                                        </div>

                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Team Lead:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectTeamLead}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.team_lead && (
                                                <span className="error-message font-size-text ">{errors.team_lead}</span>
                                            )}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Employee:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />



                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>
                                ) :
                                (<>
                                    {console.log(vendorList, 'vendorlist')}
                                    {/* *********************************************** External vender *********************************** */}
                                    {!showForm && (
                                        <div title="Vendor Name" className="flex-column form-group-selectt">
                                            <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                                Select Existing Vendor <span className="required">*</span>
                                            </label>

                                            <select
                                                id="vendor_name"
                                                name="vendor_name"
                                                value={formData?.vendor_name}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select a Vendor</option>
                                                {vendorList?.sort((a, b) => a?.name?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                    {console.log(i)}
                                                    <option value={i?.id}>{i?.name}</option>
                                                </>))
                                                }
                                            </select>
                                            <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.vendor_name && (
                                                    <span className="error-message font-size-text ">{errors.vendor_name}</span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div title="Vendor Name" className="flex-column form-group-selectt" style={{

                                        alignContent: 'flex-start',
                                        justifyItems: 'center',
                                        flexWrap: 'wrap',
                                        paddingTop: '42px',
                                    }}>
                                        <button type="button" className="common-button" onClick={handleAddVendor}>
                                            {showForm ? "- Select Existing Vendor" : " + Add New Vendor"}
                                        </button>
                                    </div>

                                    {showForm && (

                                        <div className="form-flex-wrap">

                                            <div title="name" className="flex-column">
                                                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                                                    Vender Name<span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="name"
                                                    name="name"
                                                    placeholder="Vender Name"
                                                    onChange={handleInputChange}
                                                    value={formdata2.name}
                                                    className={`form-input ${errors.name
                                                        ? "error"
                                                        : inputState.name
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.name && (
                                                    <span className="error-message font-size-text ">{errors.name}</span>
                                                )}
                                            </div>

                                            <div title="contact_person" className="flex-column">
                                                <label htmlFor="contact_person" className="form-labels font-weight500 font-size-subheading">
                                                    Contact Person
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="contact_person"
                                                    name="contact_person"
                                                    placeholder="Contact Person"
                                                    onChange={handleInputChange}
                                                    value={formdata2.contact_person}
                                                    className={`form-input ${errors.contact_person
                                                        ? "error"
                                                        : inputState.contact_person
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.contact_person && (
                                                    <span className="error-message font-size-text ">{errors.contact_person}</span>
                                                )}
                                            </div>

                                            <div title="sub_Company" className="flex-column form-group-selectt">
                                                <label htmlFor="sub_Company" className="form-labels  font-weight500    font-size-subheading">
                                                    Sub Company <span className="required">*</span>
                                                </label>
                                                <br />
                                                <select
                                                    id="sub_Company"
                                                    name="sub_Company"
                                                    value={formdata2.sub_Company}
                                                    onChange={handleInputChange}
                                                    className={`form-input form-group-selection ${errors.sub_Company ? "error" : inputState.sub_Company ? "success" : ""
                                                        }`}
                                                >
                                                    <option value="">Select a Sub Company</option>
                                                    {sub_CompanyList?.sort((a, b) => a.title.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                        {console.log(i)}
                                                        <option value={i.id}>{i.title}</option>
                                                    </>))
                                                    }
                                                </select>
                                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    {errors.sub_Company && (
                                                        <span className="error-message font-size-text ">{errors.sub_Company}</span>
                                                    )}
                                                </div>
                                            </div>

                                            <div title="address" className="flex-column">
                                                <label htmlFor="address" className="form-labels font-weight500 font-size-subheading">
                                                    Vender Address
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="address"
                                                    name="address"
                                                    placeholder="Vender Address"
                                                    onChange={handleInputChange}
                                                    value={formdata2.address}
                                                    className={`form-input ${errors.address
                                                        ? "error"
                                                        : inputState.address
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.address && (
                                                    <span className="error-message font-size-text ">{errors.address}</span>
                                                )}
                                            </div>

                                            <div title="email" className="flex-column">
                                                <label htmlFor="email" className="form-labels font-weight500 font-size-subheading">
                                                    Vender Email
                                                </label>
                                                <input
                                                    type="email"
                                                    maxLength={100}
                                                    id="email"
                                                    name="email"
                                                    placeholder="Vender Email"
                                                    onChange={handleInputChange}
                                                    value={formdata2.email}
                                                    className={`form-input ${errors.email
                                                        ? "error"
                                                        : inputState.email
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.email && (
                                                    <span className="error-message font-size-text ">{errors.email}</span>
                                                )}
                                            </div>

                                            <div title="contact_number" className="flex-column">
                                                <label htmlFor="contact_number" className="form-labels font-weight500 font-size-subheading">
                                                    Vender Number
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="contact_number"
                                                    name="contact_number"
                                                    placeholder="Client Number"
                                                    onChange={handleInputChange}
                                                    value={formdata2.contact_number}
                                                    className={`form-input ${errors.contact_number
                                                        ? "error"
                                                        : inputState.contact_number
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.contact_number && (
                                                    <span className="error-message font-size-text ">{errors.contact_number}</span>
                                                )}
                                            </div>

                                            <div title="alt_contact_number" className="flex-column">
                                                <label htmlFor="alt_contact_number" className="form-labels font-weight500 font-size-subheading">
                                                    Alternate Contact Number
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="alt_contact_number"
                                                    name="alt_contact_number"
                                                    placeholder="Alternate Contact Number"
                                                    onChange={handleInputChange}
                                                    value={formdata2.alt_contact_number}
                                                    className={`form-input ${errors.alt_contact_number
                                                        ? "error"
                                                        : inputState.alt_contact_number
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.alt_contact_number && (
                                                    <span className="error-message font-size-text ">{errors.alt_contact_number}</span>
                                                )}
                                            </div>

                                            <div title="gstin_number" className="flex-column">
                                                <label htmlFor="gstin_number" className="form-labels font-weight500 font-size-subheading">
                                                    Vender GST Number<span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="gstin_number"
                                                    name="gstin_number"
                                                    placeholder="Vender GST Number"
                                                    onChange={handleInputChange}
                                                    value={formdata2.gstin_number}
                                                    className={`form-input ${errors.gstin_number
                                                        ? "error"
                                                        : inputState.gstin_number
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.gstin_number && (
                                                    <span className="error-message font-size-text ">{errors.gstin_number}</span>
                                                )}
                                            </div>

                                            <div title="pos" className="flex-column">
                                                <label htmlFor="pos" className="form-labels font-weight500 font-size-subheading">
                                                    Place of Supply (POS)<span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    id="pos"
                                                    name="pos"
                                                    placeholder="Place of Supply"
                                                    onChange={handleInputChange}
                                                    value={formdata2.pos}
                                                    className={`form-input ${errors.pos
                                                        ? "error"
                                                        : inputState.pos
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                />
                                                {errors.pos && (
                                                    <span className="error-message font-size-text ">{errors.pos}</span>
                                                )}
                                            </div>

                                            <div className="button-models-addd">
                                                <button onClick={handleSubmitVendor} className="model-button-add">Add Vender</button>

                                            </div>

                                        </div>
                                    )}
                                </>)}









                        </div>


                        <div className="button-models-add">
                            <button onClick={handleSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
const EditDepartment = ({ i, projectID, getDepartmentList, departmentlist, getProjectDetails }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: '',
        employee: '',
        project: projectID ? projectID : "",
        department_type: 'internal',
        division_name: '',
        weightage: "",
        division_head: "",

        // name: "",
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            'department_type',
            // 'client',
            // "sub_Company",
            // "concern_person",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                // const formDataToSend = new FormData();


                // Object.keys(formData).forEach((key) => {

                //     formDataToSend.append(key, formData[key]);

                // });


                // console.log({ formDataToSend })


                let res = await axios.put(
                    `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };






    const handleShow = () => {
        console.log(i, "i")
        setFormData(i)
        setShow(true);

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/detail-design/allprojectfilter/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {
        const id = '025d0b52-e892-4868-a3bb-6b70dcdffb4d';
        try {
            const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${id}/active/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    useEffect(() => {
        if (show) {
            // setFormData((prevState) => ({
            //     ...prevState,
            //     department_type: 'internal',
            // }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
        }

    }, [show]);

    const selectTeamlead = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const team_lead = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            team_lead,
        }));
    };

    const selectheadDivision = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const division_head = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            division_head,
        }));
    };

    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const employee = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
    };

    // add Vender??/////////////////////////////////////////////////////////////

    const [formdata2, setFormData2] = useState({
        name: "",
        sub_Company: "",
        contact_person: "",
        address: "",
        email: "",
        contact_number: "",
        alt_contact_number: "",
        gstin_number: "",
        pos: ""
    })

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = [
            "sub_Company",
            "pos",
            "name",
            "gstin_number",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });





        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [sub_CompanyList, setsub_CompanyList] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const handleAddVendor = () => {
        setShowForm(!showForm);
    };
    const handleSubmitVendor = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formdata2).forEach((key) => {

                    formDataToSend.append(key, formData[key]);

                });







                let res = await axios.put(
                    `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    setShowForm(false);
                    getProjectDetails()
                    setFormData2(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getAllVendor();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const getAllsub_Company = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/subCompany/`);
            setsub_CompanyList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };
    useEffect(() => {
        getAllVendor();
        getAllsub_Company();

    }, [])
    const [vendorList, SetVendorList] = useState([]);
    const getAllVendor = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/highwaydepartment/`);
            SetVendorList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };

    console.log({ allDepartments });




    return (
        <>
            <button
                title="Edit Division"
                className="common-button"
                onClick={handleShow}
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    width="20" height="20" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill='white'
                    id="edit">
                    <path d="M3.5,24h15A3.51,3.51,0,0,0,22,20.487V12.95a1,1,0,0,0-2,0v7.537A1.508,1.508,0,0,1,18.5,22H3.5A1.508,1.508,0,0,1,2,20.487V5.513A1.508,1.508,0,0,1,3.5,4H11a1,1,0,0,0,0-2H3.5A3.51,3.51,0,0,0,0,5.513V20.487A3.51,3.51,0,0,0,3.5,24Z"></path><path d="M9.455,10.544l-.789,3.614a1,1,0,0,0,.271.921,1.038,1.038,0,0,0,.92.269l3.606-.791a1,1,0,0,0,.494-.271l9.114-9.114a3,3,0,0,0,0-4.243,3.07,3.07,0,0,0-4.242,0l-9.1,9.123A1,1,0,0,0,9.455,10.544Zm10.788-8.2a1.022,1.022,0,0,1,1.414,0,1.009,1.009,0,0,1,0,1.413l-.707.707L19.536,3.05Zm-8.9,8.914,6.774-6.791,1.4,1.407-6.777,6.793-1.795.394Z"></path></svg> Edit Division
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Division</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Type <span className="required">*</span></label>
                                <select
                                    id="department_type"
                                    name="department_type"
                                    value={formData?.department_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.department_type
                                        ? "error"
                                        : inputState.department_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Department Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.department_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.department_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData?.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                            {formData?.department_type === "internal" ? (
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels">Name Of Division<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Name of Division"
                                            name="division_name"
                                            value={formData?.division_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.division_name ? 'error' : inputState.division_name ? 'success' : ''}`}
                                        />
                                        {errors.division_name && <span className="error-message">{errors.division_name}</span>}
                                    </div>


                                    <div className="flex-column form-group-selectt">
                                        <label className="form-labels">Department <span className="required">*</span></label>

                                        {/* {console.log(formData?.department)} */}

                                        {allDepartments.length === 0 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                            </div>
                                        ) : (
                                            <>
                                                <select
                                                    id="department"
                                                    name="department"
                                                    value={formData?.department}
                                                    onChange={handleInputChange}
                                                    className={`form-input form-group-selection ${errors.department
                                                        ? "error"
                                                        : inputState.department
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="">Select a Department</option>
                                                    {allDepartments
                                                        ?.sort((a, b) =>
                                                            a?.name?.localeCompare(b.project_name, "en", {
                                                                ignorePunctuation: true,
                                                            })
                                                        )
                                                        .map((i, index) => (
                                                            <>

                                                                <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                            </>
                                                        ))}
                                                </select>
                                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    {errors.department && (
                                                        <span className="error-message font-size-text ">
                                                            {errors.department}
                                                        </span>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Head Of Division:<span className="required">*</span>
                                        </label>
                                        {console.log(formData, 'formdata')}
                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectheadDivision}
                                            value={formData?.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.division_head && (
                                            <span className="error-message font-size-text ">{errors?.division_head}</span>
                                        )}
                                    </div>

                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Team Lead:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectTeamlead}
                                            value={
                                                formData?.team_lead
                                                    ? [{
                                                        value: formData.team_lead,
                                                        label: options.find((opt) => opt.value === formData.team_lead)?.label || formData.team_lead,
                                                    }]
                                                    : []
                                            }
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.team_lead && (
                                            <span className="error-message font-size-text ">{errors.team_lead}</span>
                                        )}
                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Employee:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectEmployee}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.employee && (
                                            <span className="error-message font-size-text ">{errors.employee}</span>
                                        )}
                                    </div>
                                </>
                            ) : (<>

                                {/* *********************************************** External vender *********************************** */}
                                {!showForm && (
                                    <div title="Vendor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="department_name" className="form-labels  font-weight500    font-size-subheading">
                                            Select Existing Vendor <span className="required">*</span>
                                        </label>

                                        <select
                                            id="department_name"
                                            name="department_name"
                                            value={formData?.department_name}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.department_name ? "error" : inputState.department_name ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Vendor</option>
                                            {vendorList?.sort((a, b) => a?.title?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                {console.log(i)}
                                                <option value={i.id}>{i?.title}</option>
                                            </>))
                                            }
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors?.department_name && (
                                                <span className="error-message font-size-text ">{errors.department_name}</span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div title="Vendor Name" className="flex-column form-group-selectt" style={{

                                    alignContent: 'flex-start',
                                    justifyItems: 'center',
                                    flexWrap: 'wrap',
                                    paddingTop: '42px',
                                }}>
                                    <button type="button" className="common-button" onClick={handleAddVendor}>
                                        {showForm ? "- Select Existing Vendor" : " + Add New Vendor"}
                                    </button>
                                </div>

                                {showForm && (

                                    <div className="form-flex-wrap">

                                        <div title="name" className="flex-column">
                                            <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                                                Vender Name<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="name"
                                                name="name"
                                                placeholder="Vender Name"
                                                onChange={handleInputChange}
                                                value={formdata2.name}
                                                className={`form-input ${errors.name
                                                    ? "error"
                                                    : inputState.name
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.name && (
                                                <span className="error-message font-size-text ">{errors.name}</span>
                                            )}
                                        </div>

                                        <div title="contact_person" className="flex-column">
                                            <label htmlFor="contact_person" className="form-labels font-weight500 font-size-subheading">
                                                Contact Person
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="contact_person"
                                                name="contact_person"
                                                placeholder="Contact Person"
                                                onChange={handleInputChange}
                                                value={formdata2.contact_person}
                                                className={`form-input ${errors.contact_person
                                                    ? "error"
                                                    : inputState.contact_person
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.contact_person && (
                                                <span className="error-message font-size-text ">{errors.contact_person}</span>
                                            )}
                                        </div>

                                        <div title="sub_Company" className="flex-column form-group-selectt">
                                            <label htmlFor="sub_Company" className="form-labels  font-weight500    font-size-subheading">
                                                Sub Company <span className="required">*</span>
                                            </label>
                                            <br />
                                            <select
                                                id="sub_Company"
                                                name="sub_Company"
                                                value={formdata2.sub_Company}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.sub_Company ? "error" : inputState.sub_Company ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select a Sub Company</option>
                                                {sub_CompanyList?.sort((a, b) => a.title.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                    {console.log(i)}
                                                    <option value={i.id}>{i.title}</option>
                                                </>))
                                                }
                                            </select>
                                            <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.sub_Company && (
                                                    <span className="error-message font-size-text ">{errors.sub_Company}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div title="address" className="flex-column">
                                            <label htmlFor="address" className="form-labels font-weight500 font-size-subheading">
                                                Vender Address
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="address"
                                                name="address"
                                                placeholder="Vender Address"
                                                onChange={handleInputChange}
                                                value={formdata2.address}
                                                className={`form-input ${errors.address
                                                    ? "error"
                                                    : inputState.address
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.address && (
                                                <span className="error-message font-size-text ">{errors.address}</span>
                                            )}
                                        </div>

                                        <div title="email" className="flex-column">
                                            <label htmlFor="email" className="form-labels font-weight500 font-size-subheading">
                                                Vender Email
                                            </label>
                                            <input
                                                type="email"
                                                maxLength={100}
                                                id="email"
                                                name="email"
                                                placeholder="Vender Email"
                                                onChange={handleInputChange}
                                                value={formdata2.email}
                                                className={`form-input ${errors.email
                                                    ? "error"
                                                    : inputState.email
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.email && (
                                                <span className="error-message font-size-text ">{errors.email}</span>
                                            )}
                                        </div>

                                        <div title="contact_number" className="flex-column">
                                            <label htmlFor="contact_number" className="form-labels font-weight500 font-size-subheading">
                                                Vender Number
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="contact_number"
                                                name="contact_number"
                                                placeholder="Client Number"
                                                onChange={handleInputChange}
                                                value={formdata2.contact_number}
                                                className={`form-input ${errors.contact_number
                                                    ? "error"
                                                    : inputState.contact_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.contact_number && (
                                                <span className="error-message font-size-text ">{errors.contact_number}</span>
                                            )}
                                        </div>

                                        <div title="alt_contact_number" className="flex-column">
                                            <label htmlFor="alt_contact_number" className="form-labels font-weight500 font-size-subheading">
                                                Alternate Contact Number
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="alt_contact_number"
                                                name="alt_contact_number"
                                                placeholder="Alternate Contact Number"
                                                onChange={handleInputChange}
                                                value={formdata2.alt_contact_number}
                                                className={`form-input ${errors.alt_contact_number
                                                    ? "error"
                                                    : inputState.alt_contact_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.alt_contact_number && (
                                                <span className="error-message font-size-text ">{errors.alt_contact_number}</span>
                                            )}
                                        </div>

                                        <div title="gstin_number" className="flex-column">
                                            <label htmlFor="gstin_number" className="form-labels font-weight500 font-size-subheading">
                                                Vender GST Number<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="gstin_number"
                                                name="gstin_number"
                                                placeholder="Vender GST Number"
                                                onChange={handleInputChange}
                                                value={formdata2.gstin_number}
                                                className={`form-input ${errors.gstin_number
                                                    ? "error"
                                                    : inputState.gstin_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.gstin_number && (
                                                <span className="error-message font-size-text ">{errors.gstin_number}</span>
                                            )}
                                        </div>

                                        <div title="pos" className="flex-column">
                                            <label htmlFor="pos" className="form-labels font-weight500 font-size-subheading">
                                                Place of Supply (POS)<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="pos"
                                                name="pos"
                                                placeholder="Place of Supply"
                                                onChange={handleInputChange}
                                                value={formdata2.pos}
                                                className={`form-input ${errors.pos
                                                    ? "error"
                                                    : inputState.pos
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.pos && (
                                                <span className="error-message font-size-text ">{errors.pos}</span>
                                            )}
                                        </div>

                                        <div className="button-models-addd">
                                            <button onClick={handleSubmitVendor} className="model-button-add">Add Vender</button>

                                        </div>

                                    </div>
                                )}
                            </>)}









                        </div>


                        <div className="button-models-add">
                            <button onClick={handleSubmit} className="model-button-add">Edit</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const DepartmentDelete = ({ i, projectID, getDepartmentList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="common-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#FFF"
                    />
                </svg>

            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Departrtment {i.division_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Departrtment  {i.division_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const ActivityDelete = ({ i, projectID, getDepartmentList, intable }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false)
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/activitytype/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    console.log(intable)
    return (
        <>
            {intable ?
                <button>
                    <span className="action-menu-dropdown-button delete-button" onClick={handleShow}>

                        Remove

                    </span>
                </button>
                :
                <button
                    title="Delete Insurance"
                    className="model-delete-button"
                    onClick={handleShow}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <path
                            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                            fill="#F72B50"
                        />
                    </svg>
                </button>}



            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Active {i.activity_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Activity {i.activity_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const AddTask = () => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({

    })

    const handleShow = () => {
        setShow(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const handleTaskSubmit = async (e) => {

    }



    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Task
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Task</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Task Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the task Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    // onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Project Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Project Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity for task</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Priority<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Priority for task</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Designer:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Draftman:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Authority:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Submission Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Ststus Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {/* {selectedFile ? selectedFile.name : "Select File"} */}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    // onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>

                        <div className="">
                            <label className="form-labels">Remark <span className="required">*</span></label>
                            <textarea
                                type="text"
                                placeholder="Add Remark"
                                name="activity_name"
                                value={formData.activity_name}
                                // onChange={handleInputChange}
                                className={`form-textareaa form-inputtt  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                            />
                            {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                        </div>

                        <div className="button-models-add">
                            <button onClick={handleTaskSubmit} className="model-button-add">Add</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>

        </>
    )
};

const UpdateTask = () => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({})

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const handleTaskSubmit = async (e) => {

    }



    return (
        <>
            <button
                title="Add Detail Design"
                className="common-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Update Task</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Task Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the task Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    // onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Project Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Project Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    // onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity for task</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Priority<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Priority for task</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Designer:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Draftman:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Authority:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Submission Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Ststus Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {/* {selectedFile ? selectedFile.name : "Select File"} */}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    // onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>

                        <div className="">
                            <label className="form-labels">Remark <span className="required">*</span></label>
                            <textarea
                                type="text"
                                placeholder="Add Remark"
                                name="activity_name"
                                value={formData.activity_name}
                                // onChange={handleInputChange}
                                className={`form-textareaa form-inputtt  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                            />
                            {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                        </div>

                        <div className="button-models-add">
                            <button onClick={handleTaskSubmit} className="model-button-add">Update</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>

        </>
    )
};

const AddActivityPercentege = () => {

    const [show, setShow] = useState(false);
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({

    })
    const [errors, setErrors] = useState({});

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false)
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleweightageSubmit = () => {

    }

    return (
        <>
            <button
                title="Add Sub-Activity"
                className="common-button"
                onClick={handleShow}
            >
                <Percentage />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Activity weightage</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>


                            <div className="model-flex-column">
                                <label className="form-labels">Weightage: <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />

                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                        </div>



                        <div className="button-models-add">
                            <button onClick={handleweightageSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>


        </>
    )
}

const AddSubActivity = () => {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [formData, setFormData] = useState({

    })

    const handleShow = () => {
        setShow(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const handleTaskSubmit = async (e) => {

    }



    return (
        <>
            <button
                title="Add Sub-Activity"
                className="common-button"
                onClick={handleShow}
            >
                <AddwithWhiteCircle />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Sub-Activity</h4></Modal.Title>
                </ModalHeader>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Sub-Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Sub-Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Description<span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Description"
                                    name="description"
                                    value={formData.descriptiom}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status<span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Status</option>
                                    <option value="internal">Pending</option>
                                    <option value="external">Completed</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign To:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div>

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Draftman:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            {/* <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Assign Authority:<span className="required">*</span>
                                </label>

                                <Select
                                    // options={options}
                                    isMulti
                                    // onChange={selectEmployee}
                                    value={formData.assignedto?.map((code) => ({
                                        value: code,
                                        // label: options.find((opt) => opt.value === code)?.label || code,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />

                                {errors.employee && (
                                    <span className="error-message font-size-text ">{errors.employee}</span>
                                )}
                            </div> */}

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>

                                    <input
                                        type="date"
                                        id="assign_date"
                                        name="assign_date"
                                        value={formData.assign_date}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                    />

                                    {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}

                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Submission Date*</label>

                                    <input
                                        type="date"
                                        id="deadline_date"
                                        name="deadline_date"
                                        value={formData.deadline_date}
                                        // onChange={handleInputChange}
                                        className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                    />

                                    {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}

                                </div>

                            </div>

                            {/* <div className="flex-column form-group-selectt">
                                <label className="form-labels">Status <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    // onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Ststus Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>
                            </div> */}

                            <div
                                className={
                                    formData?.activity_type === "internal"
                                        ? "flex-column full-width-form"
                                        : "flex-column"
                                }
                            >
                                <label className="form-labels">
                                    Documentations : <span className="required">*</span>
                                </label>
                                <label
                                    className="form-input-doc full-width-form"
                                    htmlFor="uploaded_file"
                                >
                                    <DocImg />
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">
                                        {/* {selectedFile ? selectedFile.name : "Select File"} */}
                                    </span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    // onChange={handleInputChange}
                                    style={{ display: "none" }}
                                />

                                {errors.length > 0 && (
                                    <span className="error-message">{errors.length}</span>
                                )}
                            </div>

                        </div>



                        <div className="button-models-add">
                            <button onClick={handleTaskSubmit} className="model-button-add">Add</button>
                            <button type="button" onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>

                    </form>

                </Modal.Body>
            </Modal>

        </>
    )
};



const SubActivityModal = ({ subActivity }) => {
    const [showMainModal, setShowMainModal] = useState(false);
    const [showRowModal, setShowRowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleMainClose = () => setShowMainModal(false);

    const handleRowClose = () => {
        setShowRowModal(false);
        setSelectedRow(null);
    };

    const handleRowClick = (item) => {
        setSelectedRow(item);
        setShowRowModal(true);
    };

    const handleOpenModal = () => {
        setShowMainModal(true);
    };

    return (
        <>
            {/* Button to open main modal */}
            <button title="View Client Sub-Activity" onClick={handleOpenModal}>
                <span style={{ color: "#2576bc" }}>View</span>
            </button>

            {/* Main Modal */}
            <Modal
                show={showMainModal}
                onHide={handleMainClose}
                dialogClassName="Activity-model"
            >
                <ModalHeader closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <h4 className="heading-name">
                        Sub-Activity: {subActivity?.activity_name}
                    </h4>
                </ModalHeader>

                <ModalBody>
                    {subActivity?.subactivities && subActivity.subactivities.length > 0 ? (
                        <table className="Pro-details">
                            <thead>
                                <tr className="sub-activity">
                                    <th>Sub-Activity code</th>
                                    <th>Sub-Activity Name</th>
                                    {/* <th>Description</th> */}
                                    <th>Weightage</th>
                                    <th>Assign To</th>
                                    <th>Start Date</th>
                                    <th>Submission Date</th>
                                    <th>Status</th>
                                    <th>Documentation</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subActivity.subactivities.map((item) => (
                                    <tr key={item.id}>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.subactivity_code}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.subactivity_name}
                                        </td>
                                        {/* <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.description || "-"}
                                        </td> */}
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.weightage || "-"}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.assigned_to || "-"}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.start_date || "-"}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.submission_date || "-"}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.status || "-"}
                                        </td>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            {item.uploaded_file ? (
                                                <a
                                                    href={item.uploaded_file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    View Doc
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>
                                            <button onClick={() => handleRowClick(item)}>View</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p style={{ textAlign: "center" }}>No Sub-Activities Found</p>
                    )}
                </ModalBody>
            </Modal>

            {/* Row Detail Modal */}
            <Modal show={showRowModal} onHide={handleRowClose}>
                <ModalHeader closeButton>
                    <h5>Sub-Activity Details</h5>
                </ModalHeader>
                <ModalBody>
                    {selectedRow && (
                        <>
                            <p><strong>Name:</strong> {selectedRow.subactivity_name}</p>
                            <p><strong>Description:</strong> {selectedRow.description || "-"}</p>
                            <p><strong>Weightage:</strong> {selectedRow.weightage || "-"}</p>
                            <p><strong>Status:</strong> {selectedRow.status || "-"}</p>
                            <button onClick={handleRowClose}>Close</button>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

















export {
    AddActivity,
    AddDepartment,
    EditActivity, EditDepartment, DepartmentDelete, ActivityDelete, AddTask, UpdateTask,
    AddSubActivity,
    SubActivityModal,
    AddActivityPercentege
}